import React, { Component } from 'react'

import BreadcrumbProgress from './breadcrumb-progress'

class BreadcrumbProgressContainer extends Component {

  render() {
    return <BreadcrumbProgress {...this.props} />
  }

}

export default BreadcrumbProgressContainer



/** WEBPACK FOOTER **
 ** ./src/components/breadcrumb-progress/breadcrumb-progress-container.js
 **/